module.exports = "/_next/static/images/case-tracker-screenshot-2-3fb64eb27af8515e64b313e03b70e4ca.png";